var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('el-carousel',{attrs:{"interval":5000,"arrow":"hover","trigger":"click","height":"calc(100vh - var(--head-height))"}},_vm._l((_vm.img),function(src,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":src}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59afd613","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/page/home.vue
// module id = null
// module chunks = 